window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    let filters = new Swiper(
      '.sports-carousel__filters.swiper:not(.swiper-initialized)',
      {
        slidesPerView: 'auto',
        slidesPerGroup: 5,
        slidesPerGroupAuto: true,
        // centerInsufficientSlides: true,
        spaceBetween: 16,
        navigation: {
          enabled: true,
          nextEl: '.sports-carousel__filters .swiper-button-next',
          prevEl: '.sports-carousel__filters .swiper-button-prev',
        },
      },
    );

    let $filtersWrapper = $('.sports-carousel__filters');
    if ($filtersWrapper.find('.swiper-slide[data-sort-priority]').length) {
      // Set highest priority tab as active
      // $filtersWrapper.find('.swiper-slide').toggleClass('active', false);

      // let $highestPriorityFilter = $filtersWrapper.find(
      //   '.swiper-slide:first-of-type .sports-carousel__filter',
      // );

      // $filtersWrapper
      //   .find('.swiper-slide[data-sort-priority]')
      //   .each(function (idx, elem) {
      //     let $elem = $(elem);
      //     if (
      //       parseInt($elem.attr('data-sort-priority')) >
      //       parseInt($highestPriorityFilter.attr('data-sort-priority') ?? 0)
      //     ) {
      //       $highestPriorityFilter = $elem;
      //     }
      //   });

      $('.sports-carousel__carousel').addClass('active');
    }

    let selectedIndex = -1;
    $('.sports-carousel__filter.cursor-pointer').on('click', function (event) {
      if ($(this).hasClass('allow-link') == false) {
        event.preventDefault();
      }

      let number = parseInt($(this).parent().attr('aria-label').split('/')) - 1;
      selectedIndex = number;
      slideUpdate();
    });

    let mainSwiper = new Swiper(
      '.sports-carousel__carousel.swiper:not(.swiper-initialized)',
      {
        slidesOffsetBefore: 18,
        slidesOffsetAfter: 12,
        slidesPerView: 2.2,
        spaceBetween: 8,
        navigation: {
          // nextEl:
          //   '.sports-carousel__carousel-navigation-wrapper .swiper-button-next',
          // prevEl:
          //   '.sports-carousel__carousel-navigation-wrapper .swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesOffsetBefore: 24,
            slidesOffsetAfter: 24,
            slidesPerView: 2.8,
            spaceBetween: 8,
          },
          1012: {
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            slidesPerView: 3,
            spaceBetween: 16,
          },
        },
        thumbs: {
          swiper: filters,
        },
        on: {
          activeIndexChange: function () {
            selectedIndex = mainSwiper.activeIndex;
            filters.slideTo(selectedIndex);
            slideUpdate();
          },
        },
      },
    );

    let maxIndex = $('.sports-carousel__carousel .swiper-slide').length - 1;
    $('.sports-carousel__carousel-navigation-wrapper .swiper-button-prev').on(
      'click',
      function () {
        selectedIndex = Math.max(selectedIndex - 1, 0);
        mainSwiper.slideTo(selectedIndex, 300);
        slideUpdate();
      },
    );

    $('.sports-carousel__carousel-navigation-wrapper .swiper-button-next').on(
      'click',
      function () {
        selectedIndex = Math.min(selectedIndex + 1, maxIndex);
        mainSwiper.slideTo(selectedIndex, 300);
        slideUpdate();
      },
    );

    $('.sports-carousel__filters .swiper-button-next').on('click', function () {
      filters.slideNext(300, false);
    });

    function slideUpdate() {
      $('.sports-carousel__filter.cursor-pointer').removeClass('allow-link');
      $('.sports-carousel__filter.cursor-pointer')
        .eq(selectedIndex)
        .addClass('allow-link');

      $('.sports-carousel__filter.cursor-pointer').removeClass('active');
      $('.sports-carousel__filter.cursor-pointer')
        .eq(selectedIndex)
        .addClass('active');

      $('.sports-carousel__carousel .swiper-slide').removeClass('selected');
      $('.sports-carousel__carousel .swiper-slide')
        .eq(selectedIndex)
        .addClass('selected');

      $(
        '.sports-carousel__carousel-navigation-wrapper .swiper-button-prev',
      ).removeClass('swiper-button-disabled');
      if (selectedIndex <= 0) {
        $(
          '.sports-carousel__carousel-navigation-wrapper .swiper-button-prev',
        ).addClass('swiper-button-disabled');
      }

      $(
        '.sports-carousel__carousel-navigation-wrapper .swiper-button-next',
      ).removeClass('swiper-button-disabled');
      if (selectedIndex >= maxIndex) {
        $(
          '.sports-carousel__carousel-navigation-wrapper .swiper-button-next',
        ).addClass('swiper-button-disabled');
      }
    }

    // slideUpdate();
  });
});
